import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserMocks.css";
import { CircularProgressbar } from "react-circular-progressbar";
import Sidebar from "../Components/Sidebar";

const UserMocks = () => {
  const [mocks, setMocks] = useState([]);
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";

  const t = {
    title: lang === "bn" ? "আপনার মক টেস্ট ইতিহাস" : "Your Mock Test History",
    mockTest: lang === "bn" ? "মক টেস্ট" : "Mock Test",
  };

  useEffect(() => {
    const fetchMocks = async () => {
      const token = localStorage.getItem("jwtToken");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/user_mocks`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (!data.error) {
        const sorted = data.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setMocks(sorted);
      }
    };

    fetchMocks();
  }, []);

  return (
    <div className="overview">
      <Sidebar />
      <div
        className={`usr-mock-container ${lang === "bn" ? "bangla-font" : ""}`}
      >
        <h2 className="usr-mock-title">{t.title}</h2>
        <ul className="usr-mock-list">
          {mocks.map((mock) => (
            <li
              key={mock.mock_id}
              className="usr-mock-item"
              onClick={() => navigate(`/mock/${mock.mock_id}`)}
            >
              {/* <div className="usr-mock-id">{mock.mock_id}</div> */}
              <div>
                <div>📟 {t.mockTest}</div>
                <div style={{ fontWeight: 900 }}>
                  🕔 {new Date(mock.created_at).toLocaleString()}
                </div>
              </div>
              <div className="circular-progress">
                <CircularProgressbar
                  value={mock.score * 100}
                  text={`${Math.round(mock.score * 100)}%`}
                  styles={{
                    path: { stroke: "#363350" },
                    text: {
                      fill: "#363350",
                      fontSize: "20px",
                      fontWeight: "bold",
                    },
                  }}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserMocks;
